import React from 'react';
import PropTypes from 'prop-types';
import ModalLayout from '../ModalLayout';
import BasicModalLayoutFooter from '../ModalLayout/BasicModalLayoutFooter';
import { translate } from 'react-i18next';
import OnBoardingStepper from '../OnBoardingStepper';
import PhoneUtils from '@wix/wixrest-utils/dist/PhoneUtils';
import { Input } from 'wix-style-react';

class IdleContent extends React.PureComponent {
  static displayName = 'IdleContent';

  static propTypes = {
    t: PropTypes.func,
    phone: PropTypes.string,
    error: PropTypes.shape({
      type: PropTypes.string,
    }),
    countryCode: PropTypes.string,
  };

  static defaultProps = {};

  constructor() {
    super();

    this._onPhoneChange = this._onPhoneChange.bind(this);
    this._onContinue = this._onContinue.bind(this);
  }

  render() {
    const { phone, error, t, countryCode } = this.props;
    const hasError = error && error.type === 'phone';

    const title = t('phoneordering_customerinfo_addphonenumber_title');
    const cta = t('phoneordering_customerinfo_addphonenumber_cta');
    const footer = <BasicModalLayoutFooter form disabled={!phone} okText={cta} displayCancelButton={false} />;
    const status = hasError ? Input.StatusError : undefined;
    const statusMessage = hasError ? t('phoneordering_customerinfo_addphonenumber_error') : undefined;
    const prefix = <OnBoardingStepper />;

    return (
      <form onSubmit={this._onContinue} data-hook="idle-content-wrapper">
        <ModalLayout card scrollable={false} title={title} footer={footer} prefix={prefix}>
          <div style={{ height: 4 }} /> {/*spacer*/}
          <Input
            value={phone}
            onChange={this._onPhoneChange}
            autoFocus={true}
            status={status}
            statusMessage={statusMessage}
            dataHook="idle-content-phone-input"
            placeholder={PhoneUtils.getExampleNumberForType(countryCode, 1)}
          />
        </ModalLayout>
      </form>
    );
  }

  _onPhoneChange(e) {
    const { phoneChange } = this.props;
    const isValid = e.target.value.match(/^[0-9-+]*$/);
    if (isValid) {
      phoneChange({ phone: e.target.value });
    }
  }

  _onContinue(e) {
    const { phone, startOrderRequest } = this.props;

    if (e && e.preventDefault) {
      e.preventDefault();
    }

    startOrderRequest({ phone });
  }
}

export default translate()(IdleContent);
